import { useState, useEffect } from 'react'

const cache = {}

const useFetchContent = (url, defaultTitle = '') => {
  const [title, setTitle] = useState(cache[url]?.title || defaultTitle)
  const [content, setContent] = useState(cache[url]?.content || '')
  const [loading, setLoading] = useState(!cache[url])

  useEffect(() => {
    if (cache[url]) return

    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          cache[url] = { title: data.data.title, content: data.data.description }
          setTitle(data.data.title)
          setContent(data.data.description)
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [url])

  return { title, content, loading }
}

export default useFetchContent
